import { CommonTranslations } from '../CommonTranslations'
import en from './common-en'

const override: any = {
  root: {
    utils: {
      date: {
        inXDays: '{{n}} päivän kuluttua',
        tomorrow: 'Huomenna',
        today: 'Tänään',
        yesterday: 'Eilen',
        xYearsAgo: '{{n}} vuotta sitten',
        oneYearAgo: 'vuosi sitten',
        xMonthsAgo: '{{n}} kuukautta sitten',
        oneMonthAgo: 'kuukausi sitten',
        xDaysAgo: '{{n}} päivää sitten',
        oneDayAgo: 'päivä sitten',
        xHoursAgo: '{{n}} tuntia sitten',
        oneHourAgo: 'tunti sitten',
        xMinutesAgo: '{{n}} minuuttia sitten',
        oneMinuteAgo: 'minuutti sitten',
        xSecondsAgo: '{{n}} sekuntia sitten',
        oneSecondAgo: 'sekunti sitten',
      },
    },
    multiSelect: {
      tooltip: {
        atLeastItems_one:
          'Vähintään 1 kohde on valittava. Poistaaksesi tämän valinnan, valitse ensin toinen kohde.',
        atLeastItems_other:
          'Vähintään {{n}} kohdetta on valittava. Poistaaksesi tämän valinnan, valitse ensin toinen kohde.',
      },
    },
  },
}

const fi: CommonTranslations = {
  ...en,
  ...override,
}

export default fi
